type OS = 'Android' | 'iOS' | 'Linux' | 'MacOS' | 'Windows' | 'Other'

export const getCreateActSharePayload = (
  os: OS,
  link: string,
  msg: string,
): ShareData => {
  switch (os) {
    case 'Android':
      return { text: msg, url: link }
    case 'iOS':
    case 'MacOS':
      return { title: `${msg}\n${link}` }
    case 'Windows':
    case 'Linux':
      return { title: msg, url: link }
    default:
      return { url: link }
  }
}
